export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://0h5ghx1svf.execute-api.us-east-2.amazonaws.com';

export const apiUrl = (path: string) => {
  if (!path.startsWith('/')) {
    return `${API_BASE_URL}/${path}`;
  }
  return `${API_BASE_URL}${path}`;
};
